<template>
  <v-card class="rounded-card">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="6" md="7">
          <p class="mb-1">
              <span class="headline font-weight-bold text--primary">
                {{ fornecedor.nome || fornecedor.fornecedor.pessoa.nome}}
                <px-show-avaliacao-icon-simple v-if="!isFornecedorExterior"
                                               class="ml-2"
                                               :avaliacao="pontuacao"/>
              </span>
              <v-chip label v-if="score" class="ml-2">
                <px-fornecedor-score v-if="!loadingScore && score" :score="score"/>
              </v-chip>
              <v-chip v-if="fornecedor.transportadora" label>
                Transportadora
              </v-chip>
            <px-ativo class="ml-2 mb-1"
                      :ativo="!fornecedor.fornecedor.disabled && fornecedor.ativo"/>
          </p>
        </v-col>
        <v-col cols="12" sm="6" md="5" class="text-right">
          <px-fornecedor-edit v-if="hasRoleComprador"
                              :current-fornecedor="fornecedor"
                              @update="emitUpdate">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
          </px-fornecedor-edit>
        </v-col>
      </v-row>
      <p v-if="fornecedor.nome && !isFornecedorExterior"
         class="d-flex align-center">
        <v-icon>mdi-account-tie</v-icon>
        <px-span-tooltip bottom
                         tooltip="Nome receita"
                         :text="fornecedor.fornecedor.pessoa.nome"/>
      </p>
      <p class="d-flex align-center">
        <v-icon class="mb-1">mdi-domain</v-icon>
        <px-fornecedor-documento span-class="pl-1 px-0" :fornecedor="fornecedor.fornecedor"/>
        <px-regime-tributario :regime-tributario="fornecedor.fornecedor.pessoa.regimeTributario"/>
      </p>
      <p>
        <v-icon>mdi-map-marker</v-icon>
        {{ endereco }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { TipoFornecedor } from 'px-business-components';
import { computeEndereco } from '@/utils/endereco-utils';
import FornecedorEdit from '../edicao/FornecedorEdit.vue';

export default {
  props: {
    fornecedor: Object,
    score: [Object, String],
    loadingScore: Boolean,
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    pontuacao() {
      return this.score ? this.score.pontuacaoMedia : null;
    },
    endereco() {
      return computeEndereco(this.fornecedor.fornecedor.endereco);
    },
    isFornecedorExterior() {
      return this.fornecedor.fornecedor.tipo === TipoFornecedor.keys.EXTERIOR.key;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxFornecedorEdit: FornecedorEdit,
  },
};
</script>
